import {ActionMenuContext} from '#/components/actionmenu/action-menu';
import {LimitOrdersList} from '#/components/limit-orders/limit-orders';
import {FunctionComponent, useContext} from 'react';

export const ActionMenuTradeOrdersTab: FunctionComponent = () => {
  const {land} = useContext(ActionMenuContext);

  return (
    <div className='grow'>
      <LimitOrdersList land={land} />
    </div>
  );
};
